import { useSecureGraphqlQuery } from '@psyomics/ui-common';
import { useMemo } from 'react';

import {
  GetOrganisationServicesDocument,
  GetOrganisationServicesQuery,
  GetOrganisationServicesQueryVariables,
} from './generated/referrals';

type UseOrganisationServiceCodesResult = {
  serviceCodes: string[];
  fetching: boolean;
};

const useOrganisationServiceCodes = (): UseOrganisationServiceCodesResult => {
  const [{ data, fetching }] = useSecureGraphqlQuery<
    GetOrganisationServicesQuery,
    GetOrganisationServicesQueryVariables
  >({
    query: GetOrganisationServicesDocument,
  });

  const serviceCodes = useMemo(() => data?.getOrganisationServices.services.map(({ code }) => code) ?? [], [data]);

  return { fetching, serviceCodes };
};

export { useOrganisationServiceCodes };
